<template>
  <div class="page-container">
    <!-- 数据卡片区域 -->
    <div class="data-cards">
      <el-card v-for="(item, index) in stats" :key="index" class="data-card" shadow="hover">
        <div class="card-content">
          <el-icon class="card-icon">
            <component :is="item.icon" />
          </el-icon>
          <div>
            <div class="card-label">{{ item.label }}</div>
            <div class="card-value">
              <el-skeleton v-if="item.loading" :rows="0" animated />
              <span v-else>{{ item.value }}</span>
            </div>
          </div>
        </div>
      </el-card>
    </div>

    <!-- 图表区域 -->
    <div class="chart-container">
      <el-card class="chart-card" shadow="never">
        <div class="chart-header">
          <el-icon>
            <DataLine />
          </el-icon>
          <span>生成文章</span>
        </div>
        <div id="generateChart" style="height: 300px;"></div>
      </el-card>

      <el-card class="chart-card" shadow="never">
        <div class="chart-header">
          <el-icon>
            <TrendCharts />
          </el-icon>
          <span>发布文章</span>
        </div>
        <div id="publishChart" style="height: 300px;"></div>
      </el-card>
    </div>

    <!-- 热点数据区域 -->
    <div class="hotspot-container">
      <div class="hotspot-grid">
        <!-- 抖音热点 -->
        <el-card class="hotspot-card" shadow="hover">
          <div class="hotspot-header" style="background-color: #fe2c55;">
            <el-icon>
              <VideoCamera />
            </el-icon>
            <span>抖音热榜</span>
          </div>
          <div class="hotspot-list">
            <div v-for="(item, index) in douyinData" :key="item.id || index" class="hotspot-item"
              @click="openLink(item.url)">
              <span class="hotspot-rank" :style="{ color: getRankColor(index) }">{{ index + 1 }}</span>
              <span class="hotspot-text">{{ item.title }}</span>
              <span class="hotspot-hot">{{ formatHot(item.hot) }}</span>
            </div>
          </div>
        </el-card>

        <!-- 微博热点 -->
        <el-card class="hotspot-card" shadow="hover">
          <div class="hotspot-header" style="background-color: #e71f19;">
            <el-icon>
              <ChatLineRound />
            </el-icon>
            <span>微博热搜</span>
          </div>
          <div class="hotspot-list">
            <div v-for="(item, index) in weiboData" :key="item.id || index" class="hotspot-item"
              @click="openLink(item.url)">
              <span class="hotspot-rank" :style="{ color: getRankColor(index) }">{{ index + 1 }}</span>
              <span class="hotspot-text">{{ item.title }}</span>
              <span class="hotspot-hot">{{ formatHot(item.hot) }}</span>
            </div>
          </div>
        </el-card>

        <!-- 知乎热点 -->
        <el-card class="hotspot-card" shadow="hover">
          <div class="hotspot-header" style="background-color: #0084ff;">
            <el-icon>
              <Reading />
            </el-icon>
            <span>腾讯新闻</span>
          </div>
          <div class="hotspot-list">
            <div v-for="(item, index) in zhihuData" :key="item.id || index" class="hotspot-item"
              @click="openLink(item.url)">
              <span class="hotspot-rank" :style="{ color: getRankColor(index) }">{{ index + 1 }}</span>
              <span class="hotspot-text">{{ item.title }}</span>
              <span class="hotspot-author">{{ item.author }}</span>
            </div>
          </div>
        </el-card>

        <!-- 百度热点 -->
        <el-card class="hotspot-card" shadow="hover">
          <div class="hotspot-header" style="background-color: #2932e1;">
            <el-icon>
              <Search />
            </el-icon>
            <span>百度热搜</span>
          </div>
          <div class="hotspot-list">
            <div v-for="(item, index) in baiduData" :key="item.id || index" class="hotspot-item"
              @click="openLink(item.url)">
              <span class="hotspot-rank" :style="{ color: getRankColor(index) }">{{ index + 1 }}</span>
              <span class="hotspot-text">{{ item.title }}</span>
              <span class="hotspot-hot">{{ formatHot(item.hot) }}</span>
            </div>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import {
  eleme,
  Document,
  Upload,
  paperclip,
  Collection,
  Picture,
  DataLine,
  TrendCharts,
  VideoCamera,
  ChatLineRound,
  Reading,
  Search
} from '@element-plus/icons-vue'
import axios from 'axios';
import config from '@/config.js';
import Cookies from 'js-cookie';

export default {
  name: 'AppDashboard',
  components: {
    eleme,
    Document,
    Upload,
    paperclip,
    Collection,
    Picture,
    DataLine,
    TrendCharts,
    VideoCamera,
    ChatLineRound,
    Reading,
    Search
  },
  data() {
    return {
      stats: [
        { label: '账号数量', value: 0, loading: true, icon: 'eleme', key: 'total_accounts', action: 1 },
        { label: '文章数量', value: 0, loading: true, icon: 'Document', key: 'total_articles', action: 2 },
        { label: '总发布文章', value: 0, loading: true, icon: 'Upload', key: 'total_published', action: 3 },
        { label: '今日发布文章', value: 0, loading: true, icon: 'paperclip', key: 'today_published', action: 3 },
        { label: '标题数量', value: 0, loading: true, icon: 'Collection', key: 'total_titles', action: 5 },
        { label: '图库数量', value: 0, loading: true, icon: 'Picture', key: 'total_images', action: 4 }
      ],
      // 初始化数据为空数组
      douyinData: [],
      weiboData: [],
      zhihuData: [],
      baiduData: [],
      dailyGenerated: [], // 生成文章每日数据
      dailyPublished: [], // 发布文章每日数据
    }
  },
  computed: {
    userInfo() {
      return JSON.parse(Cookies.get('user_info') || '{}')
    }
  },
  mounted() {
    this.initCharts()
    this.fetchHotData()
    this.fetchDashboardStats()
    this.fetchChartData(); // 新增：获取图表数据

  },
  methods: {
    // 获取所有热点数据
    fetchHotData() {
      this.fetchDouyin()
      this.fetchWeibo()
      this.fetchZhihu()
      this.fetchBaidu()
    },

    // 获取抖音热点数据
    async fetchDouyin() {
      try {
        const response = await fetch('https://gzh.aijzdi.com/today_hot_api.php?action=getHotList&platform=douyin')
        const data = await response.json()
        if (data.code === 200) {
          this.douyinData = data.data.slice(0, 10) || []
        }
      } catch (error) {
        console.error('抖音数据获取失败:', error)
      }
    },

    // 获取微博热点数据
    async fetchWeibo() {
      try {
        const response = await fetch('https://gzh.aijzdi.com/today_hot_api.php?action=getHotList&platform=weibo')
        const data = await response.json()
        if (data.code === 200) {
          this.weiboData = data.data.slice(0, 10) || []
        }
      } catch (error) {
        console.error('微博数据获取失败:', error)
      }
    },

    // 获取知乎热点数据
    async fetchZhihu() {
      try {
        const response = await fetch('https://gzh.aijzdi.com/today_hot_api.php?action=getHotList&platform=qqnews')
        const data = await response.json()
        if (data.code === 200) {
          this.zhihuData = data.data.slice(0, 10) || []
        }
      } catch (error) {
        console.error('知乎数据获取失败:', error)
      }
    },

    // 获取百度热点数据
    async fetchBaidu() {
      try {
        const response = await fetch('https://gzh.aijzdi.com/today_hot_api.php?action=getHotList&platform=baidu')
        const data = await response.json()
        if (data.code === 200) {
          this.baiduData = data.data.slice(0, 10) || []
        }
      } catch (error) {
        console.error('百度数据获取失败:', error)
      }
    },


    // 获取图表数据
    async fetchChartData() {
      if (!this.userInfo || !this.userInfo.id) return;

      try {
        // 获取生成文章数据 (action 6)
        const generatedResponse = await axios.post(`${config.BASE_URL}/shop/api/data_statistics.php`, {
          store_id: this.userInfo.id,
          action: 6
        });

        if (generatedResponse.data && generatedResponse.data.daily_generated) {
          this.dailyGenerated = generatedResponse.data.daily_generated;
        }

        // 获取发布文章数据 (action 7)
        const publishedResponse = await axios.post(`${config.BASE_URL}/shop/api/data_statistics.php`, {
          store_id: this.userInfo.id,
          action: 7
        });

        if (publishedResponse.data && publishedResponse.data.daily_published) {
          this.dailyPublished = publishedResponse.data.daily_published;
        }

        // 更新图表
        this.updateCharts();

      } catch (error) {
        console.error('获取图表数据失败:', error);
      }
    },

    // 初始化图表
    initCharts() {
      // 生成文章柱状图
      this.genChart = echarts.init(document.getElementById('generateChart'));

      // 发布文章折线图
      this.pubChart = echarts.init(document.getElementById('publishChart'));

      // 先设置一个初始化的空图表
      this.updateCharts();
    },
    // 更新图表数据
    updateCharts() {
      // 生成文章图表
      this.genChart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        xAxis: {
          type: 'category',
          data: this.dailyGenerated.map(item => item.date),
          axisLabel: {
            rotate: 30
          }
        },
        yAxis: {
          type: 'value',
          name: '数量'
        },
        series: [{
          name: '生成文章',
          type: 'bar',
          data: this.dailyGenerated.map(item => item.count),
          itemStyle: {
            color: '#409EFF'
          },
          label: {
            show: true,
            position: 'top'
          }
        }]
      });

      // 发布文章图表
      this.pubChart.setOption({
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          data: this.dailyPublished.map(item => item.date),
          axisLabel: {
            rotate: 30
          }
        },
        yAxis: {
          type: 'value',
          name: '数量'
        },
        series: [{
          name: '发布文章',
          type: 'line',
          data: this.dailyPublished.map(item => item.count),
          itemStyle: {
            color: '#67C23A'
          },
          label: {
            show: true,
            position: 'top'
          },
          smooth: true,
          areaStyle: {
            color: {
              type: 'linear',
              x: 0, y: 0, x2: 0, y2: 1,
              colorStops: [
                { offset: 0, color: 'rgba(103, 194, 58, 0.3)' },
                { offset: 1, color: 'rgba(103, 194, 58, 0)' }
              ]
            }
          }
        }]
      });
    },
    // 获取排名颜色
    getRankColor(index) {
      const colors = ['#fe2c55', '#ff9500', '#ffcc00', '#34c759', '#5856d6', '#007aff']
      return colors[index] || '#8e8e93'
    },

    // 格式化热度值
    formatHot(hot) {
      if (!hot) return ''
      if (hot >= 10000) {
        return (hot / 10000).toFixed(1) + '万'
      }
      return hot
    },

    // 打开链接
    openLink(url) {
      if (url) {
        window.open(url, '_blank')
      }
    },

    // 修正的获取统计数据方法
    async fetchDashboardStats() {
      if (!this.userInfo || !this.userInfo.id) {
        console.error('用户信息未找到')
        this.stats.forEach(stat => {
          stat.value = '用户信息错误';
          stat.loading = false;
        });
        return
      }

      try {
        // 去重的action列表
        const uniqueActions = this.stats
          .map(stat => stat.action)
          .filter((action, index, self) => self.indexOf(action) === index);

        // 创建一个映射，记录每个action对应的卡片keys
        const actionCards = {};
        this.stats.forEach(stat => {
          if (!actionCards[stat.action]) {
            actionCards[stat.action] = [];
          }
          actionCards[stat.action].push({
            key: stat.key,
            index: this.stats.indexOf(stat)
          });
        });

        // 发送所有请求
        const requests = uniqueActions.map(action =>
          axios.post(`${config.BASE_URL}/shop/api/data_statistics.php`, {
            store_id: this.userInfo.id,
            action: action
          })
        );

        // 等待所有请求完成
        const responses = await Promise.all(requests);

        // 处理每个响应
        responses.forEach((response, idx) => {
          const data = response.data;
          const action = uniqueActions[idx];

          if (!data.error) {
            // 更新对应action的所有卡片
            actionCards[action].forEach(cardInfo => {
              const stat = this.stats[cardInfo.index];
              stat.loading = false;

              // 特殊处理action=3的数据
              if (action === 3) {
                if (cardInfo.key === 'total_published') {
                  stat.value = data.total_published || 0;
                } else if (cardInfo.key === 'today_published') {
                  stat.value = data.today_published || 0;
                }
              }
              // 其他action直接赋值
              else {
                const key = stat.key;
                stat.value = data[key] || 0;
              }
            });
          } else {
            // 处理错误
            actionCards[action].forEach(cardInfo => {
              this.stats[cardInfo.index].value = '获取失败';
              this.stats[cardInfo.index].loading = false;
            });
          }
        });

      } catch (error) {
        console.error('获取统计数据失败:', error);
        this.stats.forEach(stat => {
          stat.value = '请求失败';
          stat.loading = false;
        });
      }
    }

  }
}
</script>

<style scoped>
/* 保持原有的样式不变 */
.page-container {
  padding: 20px;
  background: #f5f7fa;
}

.page-title {
  margin-bottom: 24px;
  color: #303133;
  font-size: 24px;
}

.data-cards {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 15px;
  margin-bottom: 20px;
}

.data-card {
  border-radius: 8px;
  border: none;
}

.card-content {
  display: flex;
  align-items: center;
  padding: 15px;
}

.card-icon {
  font-size: 24px;
  margin-right: 15px;
  color: #409EFF;
}

.card-label {
  color: #909399;
  font-size: 14px;
  margin-bottom: 8px;
}

.card-value {
  color: #303133;
  font-size: 20px;
  font-weight: bold;
}

.chart-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
}

.chart-card {
  border-radius: 8px;
  border: none;
}

.chart-header {
  display: flex;
  align-items: center;
  padding: 15px;
  border-bottom: 1px solid #ebeef5;
}

.chart-header i {
  font-size: 18px;
  color: #67C23A;
  margin-right: 8px;
}

.chart-header span {
  font-size: 16px;
  color: #303133;
}

/* 热点数据样式 */
.hotspot-container {
  margin-top: 20px;
}

.hotspot-title {
  margin-bottom: 16px;
  color: #303133;
  font-size: 18px;
}

.hotspot-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.hotspot-card {
  border-radius: 8px;
  border: none;
  overflow: hidden;
}

.hotspot-header {
  padding: 12px 15px;
  color: white;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
}

.hotspot-header i {
  margin-right: 8px;
  font-size: 18px;
}

.hotspot-list {
  padding: 10px;
}

.hotspot-item {
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: background-color 0.3s;
}

.hotspot-item:hover {
  background-color: #f5f7fa;
}

.hotspot-rank {
  font-weight: bold;
  margin-right: 10px;
  width: 20px;
  text-align: center;
}

.hotspot-text {
  flex: 1;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.hotspot-hot {
  font-size: 12px;
  color: #909399;
  margin-left: 8px;
}

.hotspot-author {
  font-size: 12px;
  color: #909399;
  margin-left: 8px;
  font-style: italic;
}

/* 添加骨架屏样式 */
.card-value .el-skeleton {
  display: inline-block;
  width: 60px;
  height: 24px;
}
</style>